export class SchoolDays {
  dates: string[] = [];
  schoolDayId: number = 0;
  constructor(data?: any) {
    if(data) {
      this.dates = data.dates;
      this.schoolDayId = data.schoolDayId;
    }
  }
}